module.exports = __webpack_public_path__ + "img/transnistria.73abd88a.png";